import io from "socket.io-client";
import { settings } from "../kernel/Settings";
import isBlank from "@sedan-utils/is-blank";
function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}
function* fibonacci() {
    let a = 0;
    let b = 1;
    while (true) {
        yield a;
        [a, b] = [b, a + b];
    }
}
class EventMap {
    constructor() {
        this.deps = new Map();
    }
    add(eventType, callback) {
        this.deps.set(eventType, callback);
    }
    remove(eventType) {
        if (this.deps.has(eventType)) {
            this.deps.delete(eventType);
        }
    }
    clear() {
        this.deps.clear();
    }
}
export class MessageCenter extends EventMap {
    constructor(authStore) {
        super();
        this.authStore = authStore;
        this.prevMS = 0;
        this.fib = fibonacci();
        this.MAX_TIME = 5 * 60 * 1000;
        this.topicMap = new Map();
        this.start();
    }
    on(msgType, listener, topicKey, context) {
        if (!isBlank(this.socket)) {
            this.socket.on(msgType, listener);
        }
        super.add(msgType, listener);
        if (topicKey) {
            this.topicMap.set(topicKey, msgType);
        }
    }
    off(msgType, listener, context) {
        if (!isBlank(this.socket)) {
            this.socket.off(msgType, listener);
        }
        super.remove(msgType);
        this.topicMap.forEach((value, key, map) => {
            if (value === msgType) {
                map.delete(key);
            }
        });
    }
    offTopic(topicKey) {
        const msgType = this.topicMap.get(topicKey);
        if (msgType) {
            this.off(msgType);
        }
    }
    start() {
        const token = this.authStore.state.brainToken;
        const guest_user_key = this.authStore.state.guestToken;
        const auth = token ? { token } : { guest_user_key };
        const socket = io(settings.WS, {
            reconnection: false,
            transports: ["websocket"],
        });
        this.socket = socket;
        socket.on("connect", () => {
            console.log("socket connect");
            socket.emit("authentication", auth);
            socket.on("authenticated", (msg) => {
                console.log("authenticated", msg);
            });
        });
        this.socket.on("connect_timeout", (timeout) => {
            console.error("socket connect_timeout", timeout);
            this.socket = null;
        });
        socket.on("disconnect", (reason) => {
            console.log("socket disconnect", reason);
            this.reconnect();
        });
        socket.on("connect_error", (error) => {
            console.log("socket connect_error", error);
            this.reconnect();
        });
        socket.on("error", (error) => {
            console.log("socket error", error);
            this.reconnect();
        });
    }
    stop(cleanup = true) {
        if (isBlank(this.socket)) {
            this.socket.stop();
        }
        this.socket = null;
        if (cleanup) {
            this.topicMap.clear();
            super.clear();
        }
    }
    async reconnect() {
        console.log("websocket reconnect :>> ");
        this.stop(false);
        if (this.prevMS < this.MAX_TIME) {
            const nextNum = this.fib.next().value;
            this.prevMS = nextNum * 1000;
        }
        else {
            this.prevMS = this.MAX_TIME;
        }
        await delay(this.prevMS);
        this.start();
        this.deps.forEach((listener, eventName, map) => {
            this.on(eventName, listener);
        });
    }
}
